import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const ListDocuments = ({ title, reactTableData, ReactTableActions,id_estudio,refreshList,toggle }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        manualPageSize: [3],
        useActions: true,
        actions: (data) => ReactTableActions({ data, id_estudio,refreshList,toggle })
    };

    const columnsBudgetDocuments = [
        {
            Header: "Descripcion",
            accessor: 'descripcion',
            Cell: row => (
                <label>
                    {
                        row.value
                    }
                </label>
            )
        },
        {
            Header: "Fecha de Documento",
            accessor: 'fecha_doc',
            Cell: row => (
                <label>
                    {
                        row.value != null ?
                            moment(row.value).format("YYYY/MM/DD") : null
                    }
                </label>
            )
        },
        {
            Header: "Version",
            accessor: 'version',
            Cell: row => (
                <label>
                    {
                        row.value
                    }
                </label>
            )
        },
        {
            Header: "Clase",
            accessor: 'clase',
            Cell: row => (
                <label>
                    {
                        row.value == 1 ? "Consentimiento Informado" :
                            row.value == 2 ? "Cuestionarios de Estudio" :
                                row.value == 3 ? "Manual de Laboratorio" :
                                    row.value == 4 ? "Manual del Investigador" :
                                        row.value == 5 ? "Material de Reclutamiento" :
                                            row.value == 6 ? "Protocolo" :
                                                null
                    }
                </label>
            )
        },
        {
            Header: "Tipo",
            accessor: 'tipo',
            Cell: row => (
                <label>
                    {
                        row.value == 1 ? "Original" :
                            row.value == 2 ? "Enmienda" :
                                null
                    }
                </label>
            )
        },
        {
            Header: "Fecha de Sometimiento",
            accessor: 'fecha_sometimiento',
            Cell: row => (
                <label>
                    {
                        row.value != null ?
                            moment(row.value).format("YYYY/MM/DD") : null
                    }
                </label>
            )
        },
        {
            Header: "Fecha de Aprobacion",
            accessor: 'fecha_aprobacion',
            Cell: row => (
                <label>
                    {
                        row.value != null ?
                            moment(row.value).format("YYYY/MM/DD") : null
                    }
                </label>
            )
        },
        {
            Header: "Fecha de Aprobacion Invima",
            accessor: 'fecha_apro_invima',
            Cell: row => (
                <label>
                    {
                        row.value != null ?
                            moment(row.value).format("YYYY/MM/DD") : null
                    }
                </label>
            )
        },
        {
            Header: "Fecha Aprobacion Patrocinador",
            accessor: 'fecha_apro_patrocinador',
            Cell: row => (
                <label>
                    {
                        row.value != null ?
                            moment(row.value).format("YYYY/MM/DD") : null
                    }
                </label>
            )
        },
        {
            Header: "Estado",
            accessor: 'estado',
            Cell: row => (
                <div>
                    {row.value == 1 ? <b className="text-success">Activo</b> : <b className="text-danger">Inactivo</b>}
                </div>
                
            )
        },
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsBudgetDocuments}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

ListDocuments.propTypes = {
    budget_Documents: PropTypes.arrayOf(PropTypes.shape()),

    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default ListDocuments;
